/**
 * Picker metinleri ve para biçimi — design, coaster ve keychain picker'ının ortak yardımcısı.
 * Veri: snippets/aycan-picker-strings.liquid (picker elementinin içindeki JSON).
 *
 * Neden ayrı dosya: üç picker aynı çoğul seçimini ve aynı para biçimini kullanıyor;
 * her birine kopyalamak zamanla sessizce ayrışan üç uygulama demekti.
 *
 * Picker'lar bu nesneyi çağrı anında arar (yüklenme sırası garanti değil) ve yoksa
 * eski İngilizce metne düşer; yani bu dosya gecikse de sayfa kırılmaz.
 */
(function () {
  'use strict';

  function read(root) {
    const el = root && root.querySelector('.aycan-picker-strings');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Dilin çoğul kategorisini seçer (ar: zero/one/two/few/many/other, pl: one/few/many,
     ja: yalnız other…). Kategori dilde tanımlı değilse `other`e düşer. */
  function plural(data, key, qty, vars) {
    const forms = data && data.plural && data.plural[key];
    if (!forms) return null;
    let cat = 'other';
    try {
      cat = new Intl.PluralRules(data.lang || document.documentElement.lang || 'en').select(qty);
    } catch (e) {
      /* Intl yoksa other */
    }
    let text = forms[cat] != null ? forms[cat] : forms.other;
    if (text == null) return null;
    text = text.split('__QTY__').join(String(qty));
    if (vars) {
      Object.keys(vars).forEach((name) => {
        text = text.split(`__${name.toUpperCase()}__`).join(String(vars[name]));
      });
    }
    return text;
  }

  /* Liquid'in `money` çıktısını taklit eder. Şablon "€__AMOUNT__" / "__AMOUNT__ zł";
     örnek "1.234.567,89" (EUR) / "1,234,568" (JPY, ondalıksız) / "1 234 567,89".
     Örnekteki son ayırıcıdan sonra tam iki hane varsa o ondalık ayırıcıdır; kalan
     kısımdaki ilk rakam-dışı karakter binlik ayırıcıdır. */
  function money(data, cents) {
    const value = (Number(cents) || 0) / 100;
    const fmt = data && data.money;
    if (!fmt || !fmt.template || !fmt.sample) return `$${value.toFixed(2)}`;

    const sample = String(fmt.sample);
    const tail = sample.match(/(\D)(\d+)$/);
    const decimals = tail && tail[2].length === 2 ? 2 : 0;
    const decimalSep = decimals ? tail[1] : '';
    const intSample = decimals ? sample.slice(0, -(tail[0].length)) : sample;
    const thousands = intSample.match(/\d(\D+)\d/);
    const thousandsSep = thousands ? thousands[1] : '';

    const parts = value.toFixed(decimals).split('.');
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    const amount = decimals ? `${intPart}${decimalSep}${parts[1]}` : intPart;
    return fmt.template.split('__AMOUNT__').join(amount);
  }

  window.AycanPickerI18n = { read, plural, money };
})();
